<header class="header desktop-header" *ngIf="!isMobile">
	<div class="row">
		<div class="navrow col-md-2">
			<a [routerLink]="['/dashboard']" class="d-table">
				<img width="95" src="assets/images/revup-logo.jpg" alt="Logo">
			</a>
		</div>
		<div class="navrow col-md-10">
			<ul class="header_cont">
				<li>
					<div class="status_group" *ngIf="loanAppNumber" >
						<kendo-label>Status: </kendo-label>
						<kendo-dropdownlist
						[style.width.px]="230"
						(valueChange)="updateStatus ($event)"
						[disabled]="statusDisabled"
						[(value)]="status"
						textField="text"
						valueField="value"
						[itemDisabled]="isItemDisabled"
						[data]="statusList"></kendo-dropdownlist>
						<!-- Admin-only, and only on a file marked Deal Fell Through. Clears the
						     appraisal, title and flood orders and puts the address back to TBD. -->
						<app-reset-file-apis [section]="'all'" [loanApplicationId]="loanAppId" />
						<app-share-with-customer [loanApplicationId]="loanAppId" [customerOriginated]="customerOriginated" />
					</div>
				</li>
				<li>
					<div class="form-group mb-0" *ngIf="loanAppNumber">
						<label>File ID: </label>
						<span>
							{{loanAppNumber}}
						</span>
					</div>
				</li>
				<li>
					<div class="form-group mb-0" *ngIf="loanAppNumber && factualDataId && factualDataId != ''">
						<label>Factual Data ID: </label>
						<span>{{factualDataId}}</span>
					</div>
				</li>
				<li>
					<div class="form-group mb-0" *ngIf="helperService.loan_application_id && helperService.loan_application_id != ''">
						<label>Application ID: </label>
						<span> {{helperService.loan_application_id}}</span>
					</div>
				</li>

				<li>
					<div class="profile_cont" (click)="onClickProfile()">
						<label>{{authService.userInfo?.namefirst}}</label>
						<img src="assets/images/avatar.png" alt="Profile">
					</div>
				</li>
			</ul>
		</div>
	</div>

</header>

<header class="header mobile-header" *ngIf="isMobile">
	<div class="mobile-top-bar">
		<div class="mobile-hamburger" (click)="onLeftSideMenu()">
			<img src="./assets/images/sidebar/dashboard.svg" alt="Menu"/>
		</div>
		<div class="mobile-logo">
			<a [routerLink]="['/dashboard']">
				<img width="85" src="assets/images/revup-logo.jpg" alt="Logo">
			</a>
		</div>
		<div class="mobile-profile">
			<div class="profile_cont" (click)="onClickProfile()">
				<img src="assets/images/avatar.png" alt="Profile">
			</div>
		</div>
	</div>
	<div class="mobile-loan-info" *ngIf="loanAppNumber">
		<div class="status_group" *ngIf="loanAppNumber">
			<kendo-label>Status: </kendo-label>
			<kendo-dropdownlist
				(valueChange)="updateStatus($event)"
				[disabled]="statusDisabled"
				[itemDisabled]="isItemDisabled"
				[(value)]="status"
				textField="text"
				valueField="value"
				[data]="statusList">
			</kendo-dropdownlist>
			<app-reset-file-apis [section]="'all'" [loanApplicationId]="loanAppId" />
						<app-share-with-customer [loanApplicationId]="loanAppId" [customerOriginated]="customerOriginated" />
		</div>
		<div class="loan-ids">
			<span class="form-group mb-0" *ngIf="loanAppNumber"><label>File ID: </label> {{loanAppNumber}}</span>
			<span class="form-group mb-0" *ngIf="loanAppNumber && factualDataId && factualDataId != ''"><label>Factual Data ID: </label> {{factualDataId}}</span>
			<span class="form-group mb-0" *ngIf="helperService.loan_application_id && helperService.loan_application_id != ''"><label>App ID: </label> {{helperService.loan_application_id}}</span>
		</div>
	</div>
</header>


<div class="reset-data" *ngIf="showReset">
	<div class="item" *ngIf="loanAppId && canDeleteLoanApplication" (click)="deleteLoanApplication(loanAppId)">Delete Loan Application</div>
	<div class="item" [class.logout]="loanAppId && canEditLoanApplication" (click)="authService.logout('USER_INITIATED')">Logout</div>
</div>


<!-- allowHtml is safe here: the server builds this string from a fixed label table, never from
     anything a user typed. -->
<app-validation-error-dialog
	[isOpen]="dialogOpened"
	title="This status change is blocked"
	[intro]="dialogIntro"
	[details]="dialogDetails"
	[message]="dialogMessage"
	[allowHtml]="true"
	(closed)="close()">
</app-validation-error-dialog>

<kendo-dialog title="Delete Loan Application" *ngIf="deleteConfirmOpened" (close)="cancelDelete()" [minWidth]="250" [width]="450">
	<p style="margin: 25px 20px; text-align: center; line-height: 1.5;">
		Are you sure you want to delete this loan application? This action is permanent and cannot be undone.
	</p>
	<kendo-dialog-actions>
		<button kendoButton [themeColor]="'base'" (click)="cancelDelete()" [disabled]="isDeleting">Cancel</button>
		<button kendoButton [themeColor]="'error'" (click)="confirmDelete()" [disabled]="isDeleting">
			{{ isDeleting ? 'Deleting…' : 'Delete' }}
		</button>
	</kendo-dialog-actions>
</kendo-dialog>

<!-- Moving to Deal Fell Through blanks the property address server-side, so it is confirmed
     first. Cancelling puts the dropdown back to the status the file actually has. -->
<kendo-dialog title="Change status to Deal Fell Through?" *ngIf="pendingDealFellThrough"
	(close)="cancelDealFellThrough()" [minWidth]="250" [width]="520">
	<div style="margin: 25px 25px; line-height: 1.6;">
		<p>
			The property address on this file will be changed to <b>TBD</b>.
		</p>
		<p *ngIf="pendingDealFellThroughAddress">
			Current address: <b>{{ pendingDealFellThroughAddress }}</b>
		</p>
	</div>
	<kendo-dialog-actions>
		<button kendoButton [themeColor]="'base'" (click)="cancelDealFellThrough()">Cancel</button>
		<button kendoButton [themeColor]="'error'" (click)="confirmDealFellThrough()">Change status</button>
	</kendo-dialog-actions>
</kendo-dialog>
